import { featureFlag } from "./featureFlags";

export type FeatureFlags =
  | "FEATURE_FLAG_DISCORD_GIVEAWAY_0123"
  | "SEGMENT"
  | "HARDCODE_HAMILTON_HOLDINGS"
  | "CASH_HOLDINGS_ENABLE"
  | "FEATURE_FLAG_APRIME_PRICING_GRAPH";

export const FLAGS = {
  isECFEnabled: featureFlag("ecf"),
};

/**
 * This is the list of high level pages that are protected by feature flags.
 */
export const FEATURE_FLAGGED_PAGES: { [key: string]: boolean[] } = {
  "/kyc": [featureFlag("ecf"), featureFlag("hackathon")],
  "/portfolio": [featureFlag("ecf"), featureFlag("hackathon")],
};

/**
 * Whitelist of countries that are allowed to access the page
 * Only declare the country code here if the pages is not allowed to be accessed by all countries
 */
export const COUNTRY_FLAGGED_PAGES: { [key: string]: string[] } = {
  "/kyc": ["MY", "SG"],
  "/portfolio": ["MY", "SG"],
};
